import {Alert, Snackbar} from "@mui/material";
import {CUSTOM_SNACKBAR} from "@/components/snackbar/types";

const CustomSnackbar = (props: CUSTOM_SNACKBAR) => {
    return <Snackbar
        open={props.open}
        autoHideDuration={props?.duration ?? 10000}
        onClose={props.handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
        <Alert
            onClose={props.handleClose}
            severity={props.severity ?? "success"}
            variant={props?.variant ?? "filled"}
            sx={{ ...(props.styles ?? {}) }}
        >
            {props.message}
        </Alert>
    </Snackbar>
}

export default CustomSnackbar;